import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef, EventEmitter, Output, QueryList, ViewChildren} from "@angular/core";
import { ValidatorService } from "src/app/shared/validator.service";
import { ControlContainer, FormsModule, NgForm } from "@angular/forms";
import { CommonModule, KeyValue } from "@angular/common";
import { InputType } from "../add-edit-users-models";
import { TranslateModule } from "@ngx-translate/core";
import { CustomSelectComponent } from "src/app/shared/custom-select/custom-select.component";

@Component({
    selector: 'app-base-user-info',
    templateUrl: "./base-user-info.component.html",
    styleUrls: ["./base-user-info.component.scss"],
    changeDetection: ChangeDetectionStrategy.OnPush,
    viewProviders: [ { provide: ControlContainer, useExisting: NgForm } ],
    imports: [CommonModule, TranslateModule, CustomSelectComponent, FormsModule]
  })
  export class BaseUserInfoComponent{

    constructor(public validator: ValidatorService, private changeDetectorRef : ChangeDetectorRef)
    {}

    inputs : any = {}

    @Output()
    changeEvent : EventEmitter<any> = new EventEmitter<any>();

    @ViewChildren("inputContainer") inputContainers : QueryList<ElementRef>;

    emitChangeEvent()
    {
      this.changeEvent.emit();
    }

    public checkChanges()
    {
      this.changeDetectorRef.markForCheck();
    }

    public orderByValueAsc(a: KeyValue<string, InputType>, b: KeyValue<string, InputType>) : number
    {
      return a.value.formOrder - b.value.formOrder
    }

  }
